import React, { useEffect, useRef, useState } from 'react';

// Msal imports
import { MsalAuthenticationTemplate, useMsal, useAccount } from '@azure/msal-react';
import { InteractionType, InteractionStatus, InteractionRequiredAuthError } from '@azure/msal-browser';
import { getConfig } from '../../config';

// Sample app imports
import { Loading } from './Loading';
import { ErrorComponent } from './ErrorComponent';
import { clearUserData } from 'utils/cleardata';


export const Protected = ({ children }) => {
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [hasToken, setHasToken] = useState(null);
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!hasToken && account && inProgress === InteractionStatus.None) {
      const request = {
        scopes: [getConfig().msalConfig.auth.clientId],
        account: account
      };
      instance.acquireTokenSilent(request).then((response) => {
        if (mounted.current) {
          setHasToken(response);
        }
      }).catch((e) => {
        clearUserData();
        if (e instanceof InteractionRequiredAuthError) {
          instance.acquireTokenRedirect(request);
        }
      });
    }
  }, [account, inProgress, instance, hasToken]);

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={{
        scopes: [getConfig().msalConfig.auth.clientId]
      }}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      { children }
    </MsalAuthenticationTemplate>
  );
};
